var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MortgagesWrapper',{attrs:{"operations":_vm.operations,"loading":_vm.loading,"pagination":_vm.pagination,"status-list":_vm.statusList,"lost-reason-prefix":"mortgage_lost_reason_"}})}
var staticRenderFns = []

export { render, staticRenderFns }